import { Col, Row, Layout } from 'antd';
import * as qs from 'query-string';
import React from 'react';
import LoginForm from '../../components/Login/LoginForm';
import LoginHeader from '../../components/Login/LoginHeader';
import ResetPasswordRequestForm from '../../containers/CrudForms/ResetPasswordRequestForm';
import ResetPasswordForm from '../../containers/CrudForms/ResetPasswordForm';

interface Props {}
interface State {
  mode: string;
  token: string | null;
}

class Login extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      mode: 'login',
      token: null
    };

    this.onModeChange = this.onModeChange.bind(this);
  }

  getToken() {
    let token: any = null;
    let queryParams = qs.parse(window.location.search);
    if (Object.keys(queryParams).indexOf('access_token') > -1) {
      token = queryParams.access_token;
    }
    return token;
  }

  componentDidMount() {
    let token = this.getToken();
    this.setState({ token: token, mode: token ? 'reset-password' : 'login' });
  }

  onModeChange = (value: string) => {
    this.setState({ mode: value });
  };

  render() {
    let title = 'Inloggen';
    if (this.state.mode === 'reset-request') {
      title = 'Wachtwoord resetten';
    } else if (this.state.mode === 'reset-password') {
      title = 'Wachtwoord instellen';
    }
    return (
      <Layout
        style={{
          minHeight: '100vh',
          background: '#D9D8D0'
        }}
      >
        <Row style={{ height: '100vh' }}>
          <Col style={{ height: '100%' }} xs={0} sm={0} lg={18}>
            <img
              src={require('../../images/logistics-promo.jpg')}
              alt='logo'
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover'
              }}
            />
          </Col>
          <Col xs={24} sm={24} lg={6} style={{ padding: '50px', height: '100%' }}>
            <Row style={{ height: '100%' }}>
              <Row style={{ margin: '80px 0 40px 0' }}>
                <Col lg={24}>
                  <LoginHeader title={title} />
                </Col>
              </Row>
              {this.state.mode === 'login' && <LoginForm onModeChange={this.onModeChange} />}
              {this.state.mode === 'reset-request' && (
                <ResetPasswordRequestForm onModeChange={this.onModeChange} />
              )}
              {this.state.mode === 'reset-password' && (
                <ResetPasswordForm token={this.state.token} onModeChange={this.onModeChange} />
              )}
              {process.env.REACT_APP_VERSION && (
                <div style={{ textAlign: 'center', color: '#ccc' }}>
                  Versie #{process.env.REACT_APP_VERSION}
                </div>
              )}
            </Row>
            <Row>
              <Col style={{ textAlign: 'center' }}>
                <a
                  href='https://www.teamviewer.com/nl/download/windows'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ textDecoration: 'underline' }}
                >
                  Teamviewer downloaden
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
      </Layout>
    );
  }
}

export default Login;
